import { createSlice } from '@reduxjs/toolkit';

const clientSlice = createSlice( {
  name: 'clientData',
  initialState: { clientInfo: {} },
  reducers: {
    setNeonApiKey( state, action ) {
      state.clientInfo = {
        ...action.payload.abbreviation && { name: action.payload.abbreviation },
        ...action.payload.neonAdminToken && { adminToken: action.payload.neonAdminToken },
        ...action.payload.apiKey && { apiKey: action.payload.apiKey },
        ...action.payload.neonClientName && { neonClientName: action.payload.neonClientName },
        ...action.payload.neonOauthId && { neonOauthId: action.payload.neonOauthId },
        ...action.payload.neonOauthSecret && { neonOauthSecret: action.payload.neonOauthSecret }
      };
    },
    clearState( state, action ) {
      if ( action === 'CLEAR_SESSION' ) {
        state = undefined;
      }
    }
  }
} );

export const clientActions = clientSlice.actions;

export default clientSlice.reducer;